import * as React from "react";
import { parseIban, Transfer } from "../../domain/payment";
import { constNull, pipe } from "fp-ts/function";
import { option } from "fp-ts";
import { QrCode, QrDataUrl } from "./QrCode";
import { Option } from "fp-ts/Option";

interface Props {
    transfer: Transfer;
    qrDataUrl: Option<QrDataUrl | string>;
}

/*inline style so we can use this in react email */
export const TransferView = (p: Props) => {
    const parsedIban = parseIban(p.transfer.iban);

    return (
        <>
            {pipe(
                parsedIban.localFormat,
                option.fromNullable,
                option.fold(constNull, (localFormat) => (
                    <Row label={"Bankovní účet"} value={localFormat} />
                ))
            )}
            <Row label={"IBAN"} value={p.transfer.iban} />
            {pipe(
                p.transfer.bic,
                option.fromNullable,
                option.fold(constNull, (bic) => (
                    <Row label={"BIC/SWIFT"} value={bic} />
                ))
            )}
            <Row label={"Variabilní symbol"} value={p.transfer.reference} />
            <Row
                label={`Částka (${p.transfer.currency})`}
                value={p.transfer.amount}
            />
            <Row label={"Zpráva pro příjemce"} value={p.transfer.msg} />
            {pipe(
                p.qrDataUrl,
                option.fold(constNull, (dataUrl) => (
                    <div
                        style={{
                            clear: "both",
                            display: "flex",
                            paddingTop: "1cm",
                            justifyContent: "center",
                        }}
                    >
                        <QrCode url={dataUrl} title={"QR platba"} />
                    </div>
                ))
            )}
        </>
    );
};

interface RowProps {
    label: React.ReactNode;
    value: React.ReactNode;
}

const Row = (p: RowProps) => (
    <p style={{ clear: "both" }}>
        <span style={{ float: "left", color: "#757575" }}>{p.label}</span>
        <span style={{ float: "right", color: "#000000" }}>{p.value}</span>
        {/*TODO copy value button */}
    </p>
);
